import MobileStore from "../../component/mobile/store/M_Store";
import Store from "../../component/store/Store";

const STORE = () => {
  return (
    <div className="STORE">
      {window.innerWidth > 1000 && <Store />}
      {window.innerWidth < 1000 && <MobileStore />}
    </div>
  );
};

export default STORE;
